import { useQuery } from 'react-query'
import { fetchAPI } from 'framework/api/http'

/* Get all sample users */
export const getAllSampleUsers = async () => {
  const res = await fetchAPI('/users')
  return res
}

/* Use Query as a Hook */
export const useSample = () => {
  return useQuery('sample-users', () => getAllSampleUsers())
}
